/**
 * LoadMore controller.
 *
 * This class controls the load more functionalilty.
 */

const { __, sprintf } = wp.i18n;

/**
 * Class LoadMore
 */
class LoadMore {

    /**
     * Class constructor is for binding class properties.
     */
    constructor() {

        // Current pagination number in.
        this.page = 0;

        // Max number of pages available.
        this.maxPage = 0;
    }

    /**
     * Cache dom elements for use in the class's methods
     */
    cache() {
    }

    /**
     * All common events
     * @return {void}
     */
    events() {
    }

    /**
     * Set up required class variables and call getPosts.
     *
     * @param {obj} e       Load more click event.
     * @param {obj} element Captured load more element.
     */
    loadMore( e, element ) {

        this.initLoadMore( element );

        // Increment this.page and call getPosts.
        this.page++;
        this.getPosts();
    }

    /**
     * Set up required class variables.
     *
     * @param {*} el Load more click target.
     */
    initLoadMore( el ) {
        if ( ! this.page ) {

            this.loadMoreBtn = el;

            const dataPage = this.loadMoreBtn.getAttribute( 'data-page' );
            this.page = dataPage ? parseInt( dataPage ) : 1;

            const dataMaxPage = this.loadMoreBtn.getAttribute( 'data-maxpage' );
            this.maxPage = dataMaxPage ? parseInt( dataMaxPage ) : 1;

            // Get info about what DustPress model should be used when retrieving data.
            this.dpModel = this.loadMoreBtn.getAttribute( 'data-model' );

            // Get info about what DustPress partial should be used when retrieving data.
            this.dpPartial = this.loadMoreBtn.getAttribute( 'data-partial' );

            // Define the element where the loaded posts will we appended to.
            const targetElementId = this.loadMoreBtn.getAttribute( 'data-target' );

            if ( targetElementId ) {
                this.targetElement = document.getElementById( targetElementId );
            }

            // Get the slug that will be used for the pagination url.
            const pageSlug = this.loadMoreBtn.getAttribute( 'data-pageslug' ) ;
            this.pageSlug = pageSlug ? pageSlug : 'page';

            // Define RegExp that will be used when checking if current pathname contains the pageslug.
            this.pageSlugPattern = new RegExp( this.pageSlug );

            // Define a RegExp that will be used when replacing the current path while manipulating history.
            // Matches when a string ends with the pageslug followed by a slash and digits (and possible a slash).
            // Example matches when pageslug is page: foo/page/2 and foo/bar/page/14/
            this.pageSlugReplacePattern = new RegExp( this.pageSlug + '\/(\\d+)\/?' );

            // Check if a queryString has been defined. If so, it will be used to manipulate the history instead of the
            // page-slug.
            this.queryString = this.loadMoreBtn.getAttribute( 'data-querystring' );
        }
    }

    /**
     * Use DustPress JS to load more posts.
     */
    getPosts() {

        // Return early if model or partial missing
        if ( ! this.dpModel || ! this.dpPartial ) {
            return;
        }

        // Change the loading state.
        this.toggleLoader( true );

        dp( this.dpModel, {
            partial: this.dpPartial,
            tidy: true,
            data: true,
            args: {
                page: this.page
            }
        }).then( ( data ) => {
            this.successHandler( data );
        }).catch( ( error ) => {
            this.errorHandler( error );
        });
    }

    /**
     * Manipulates browser history, appends data to DOM and toggles loading state.
     *
     * @param {mixed} data Data usually returned from a DustPress JS ajax request.
     */
    successHandler( data ) {

        this.manipulateHistory();

        // Append search results to searchResultsContainer. Also checking data variable. It might be false if
        // trying to get data from a DustPress model that does not exist.
        if ( this.targetElement && data.success ) {

            // Get the last article before appending and the number of articles before loading in the new result set
            const currentLastChild   = this.targetElement.lastElementChild;
            const articlesBeforeLoad = this.targetElement.getElementsByTagName( 'article' ).length;

            // Append the search results
            this.targetElement.insertAdjacentHTML( 'beforeend', data.success );

            // The number of articles loaded
            const articlesLoaded = this.targetElement.getElementsByTagName( 'article' ).length - articlesBeforeLoad;

            // Inform screen readers of the change
            /* translators: number of loaded articles */
            wp.a11y.speak( sprintf( __( '%d new articles loaded.', 'the-dustpress-theme' ), articlesLoaded ), 'polite' );

            // Change the focus to the first appended element's title link
            const nextSiblingLinks = currentLastChild.nextElementSibling.getElementsByClassName( 'js-load-more-focus' );
            if ( nextSiblingLinks.length ) {
                nextSiblingLinks[0].focus();
            }
        }

        // Bind new lazy-load images.
        const lazyImages = Theme.Common.$( '.js-lazyload-img', this.targetElement );
        this.viewportVisibility.scrollTrigger.bind( lazyImages );

        // Make ScrollTrigger think an scroll event happened.
        this.viewportVisibility.scrollTrigger.scrollDidChange();

        // Change loading state. Call with loading state as false, so that the button gets removed if needed.
        this.toggleLoader( false );
    }

    /**
     * Handles failed DustPress JS request.
     *
     * @param {mixed} error Error returned by failed DustPress JS request.
     */
    errorHandler( error ) {
        this.toggleLoader( false );
        console.log( error );
    }

    /**
     * Manipulate the window history by adding or changing the page number in the url.
     */
    manipulateHistory() {

        // Return early if history manipulation not supported.
        if ( ! window.history ) {
            return;
        }

        // Manipulate querys string if it is defined.
        if ( this.queryString ) {
            const url = this.updateQueryStringParameter( window.location.href, this.queryString, this.page );
            window.history.replaceState({}, '', url );
            return;
        }

        // Check if history is supported in browser and required variables are set.
        if ( this.pageSlug && this.pageSlugPattern && this.pageSlugReplacePattern ) {
            let path = location.pathname;

            // Check if the url contains a page and replace the current location with the new state.
            // Remove pagination from current path.
            if ( this.pageSlugPattern.test( location.pathname ) ) {
                path = location.pathname.replace( this.pageSlugReplacePattern, '' );
            }

             // Remove possible slash from end of path
            path = path.replace( /\/$/, '' );

             // Add pagination to path.
            path = path + '/' + this.pageSlug + '/' + this.page + '/';

             // Push the newly generated url to history.
            const url = window.location.protocol + '//' + location.host + path;
            window.history.replaceState({}, '', url );
        }
    }

    /**
     * Add or update a query string parameter
     * @link https://stackoverflow.com/a/6021027
     *
     * @param {string} uri The entire url of the page.
     * @param {string} key The query string key.
     * @param {string} value The query string value.
     * @return {string} The url with the updated query string
     */
    updateQueryStringParameter( uri, key, value ) {
        const re = new RegExp( '([?&])' + key + '=.*?(&|$)', 'i' );
        const separator = uri.indexOf( '?' ) !== -1 ? '&' : '?';
        if ( uri.match( re ) ) {
            return uri.replace( re, '$1' + key + '=' + value + '$2' );
        } else {
            return uri + separator + key + '=' + value;
        }
    }

    /**
     * Changes the state of the loader.
     *
     * @param {bool} isLoading The current loading state of the app. If false, checks if the button should be removed.
     */
    toggleLoader( isLoading = true ) {
        if ( this.loadMoreBtn ) {

            // Toggle button loading state.
            this.loadMoreBtn.classList.toggle( 'is-loading' );

            // Hide load more button if there is nothing more to load.
            if ( ! isLoading && ( this.page >= this.maxPage ) ) {
                const btnParent = this.loadMoreBtn.parentNode;
                if ( btnParent.classList.contains( 'js-remove-when-empty' ) ) {
                    btnParent.parentNode.removeChild( btnParent );
                } else {
                    btnParent.removeChild( this.loadMoreBtn );
                }
            }
        }

        // Change target aria-busy status depending on loading state.
        // @link http://csskarma.com/blog/using-aria-live-regions/
        if ( this.targetElement ) {

            if ( isLoading ) {
                this.targetElement.setAttribute( 'aria-busy', 'true' );
            } else {
                this.targetElement.setAttribute( 'aria-busy', 'false' );
            }
        }
    }

    /**
     * Run when the document is ready.
     */
    docReady() {
        this.viewportVisibility = Theme.getController( 'ViewportVisibility' );
        this.cache();
        this.events();
    }
}

// Export the class reference.
module.exports = LoadMore;



// WEBPACK FOOTER //
// ./assets/scripts/load-more.js